export const getBrands = ({ brands }) => brands;

export const getTitle = state => getBrands(state).title;

const isBrandNotExcluded = ({ channelExclusions = [] }) =>
  !channelExclusions.some(filter => filter.toLowerCase().includes("web"));

const isGroupWithBrands = brands => brands.length > 0;

export const getListOfBrands = state => {
  const { groups = [] } = getBrands(state);

  return groups.reduce((groupsInStock, group) => {
    const [title, brands] = group;
    const brandsNotExcluded = brands.filter(isBrandNotExcluded);

    if (isGroupWithBrands(brandsNotExcluded)) {
      groupsInStock.push([title, brandsNotExcluded]);
    }

    return groupsInStock;
  }, []);
};
